import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";

export const useCheckAuth = () => {
	return useQuery({
		queryKey: ["check-auth"],
		queryFn: () => privateAxios.get("/auth/check-auth"),
		retry: false,
	});
};
